import { AlertTriangle } from 'lucide-react';

interface GenerateDraftPicksModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  numberOfRounds: number;
  loading?: boolean;
}

export function GenerateDraftPicksModal({ 
  show, 
  onHide, 
  onConfirm, 
  numberOfRounds,
  loading = false 
}: GenerateDraftPicksModalProps) {
  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-warning text-dark">
            <h5 className="modal-title d-flex align-items-center">
              <AlertTriangle size={24} className="me-2" />
              Avertissement - Génération des choix de repêchage
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onHide}
              disabled={loading}
              aria-label="Close"
            ></button>
          </div>
          
          <div className="modal-body">
            <div className="alert alert-warning d-flex align-items-start">
              <AlertTriangle size={20} className="me-2 mt-1 flex-shrink-0" />
              <div>
                <strong>Attention :</strong> Cette action va générer <strong>{numberOfRounds} rondes</strong> de choix de repêchage pour toutes les équipes de la ligue.
              </div>
            </div>
            
            <div className="mb-3">
              <p className="mb-2">
                <strong>À faire seulement avant le début d'une nouvelle saison après votre draft</strong>, 
                sinon vous allez perdre les mouvements de choix de repêchage effectués dans les transactions.
              </p>
              
              <p className="mb-0 text-muted">
                Cette action va :
              </p>
              <ul className="text-muted mb-0">
                <li>Supprimer tous les choix de repêchage existants pour cette ligue</li>
                <li>Créer {numberOfRounds} choix (1ère à {numberOfRounds}e ronde) pour chaque équipe</li>
                <li>Permettre aux équipes d'échanger ces choix dans les transactions</li>
              </ul>
            </div>
            
            <p className="text-danger fw-bold">
              Êtes-vous sûr de vouloir continuer ?
            </p>
          </div>
          
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onHide} 
              disabled={loading}
            >
              Annuler
            </button>
            <button 
              type="button"
              className="btn btn-warning d-flex align-items-center" 
              onClick={onConfirm}
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              )}
              Continuer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
